<template>
  <div v-html="compiledMarkdown" class="markdown-body"></div>
</template>

<script>
import MarkdownIt from "markdown-it";
import MarkdownItAnchor from "markdown-it-anchor";
import MarkdownItPrompt from "./MarkdownItPrompt"; // 如有自定义插件请确保已安装
import MarkdownItTable from "./MarkdownItTable"; // 如有自定义插件请确保已安装

export default {
  name: "MarkdownRenderer",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  computed: {
    compiledMarkdown() {
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      });
      md.use(MarkdownItAnchor, {
        permalink: false,
        permalinkAttrs: () => ({ target: "_blank", rel: "noopener" }),
      });
      md.use(MarkdownItPrompt);
      md.use(MarkdownItTable);

      // #region 全局设置所有a标签target
      const defaultRender =
        md.renderer.rules.link_open ||
        function (tokens, idx, options, env, self) {
          return self.renderToken(tokens, idx, options);
        };
      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const aIndex = tokens[idx].attrIndex("target");
        if (aIndex < 0) {
          tokens[idx].attrPush(["target", "_blank"]);
          tokens[idx].attrPush(["rel", "noopener"]);
        }
        return defaultRender(tokens, idx, options, env, self);
      };
      // #endregion

      return md.render(this.content || "");
    },
  },
};
</script>

<style lang="scss">
.markdown-body {
  font-size: 14px;
  line-height: 1.7;
  word-break: break-word;

  pre {
    background: #f6f8fa;
    padding: 8px;
    border-radius: 4px;
    overflow-x: auto;
  }

  code {
    background: #f6f8fa;
    padding: 2px 4px;
    border-radius: 2px;
  }

  a {
    color: #1818fd;
    text-decoration: underline;
  }

  ul {
    list-style-type: disc;
    list-style-position: inside;
  }

  ol {
    list-style-type: decimal;
    list-style-position: inside;
  }

  &::after {
    white-space: pre-wrap;
  }

  a {
    color: #1818fd;
    text-decoration: underline;
  }

  pre {
    white-space: pre-wrap;
  }

  .custom-table {
    width: 100%;
    border-collapse: collapse;
  }

  .custom-thead {
    background-color: #f5f5f5;
  }

  .custom-tbody {
    background-color: #ffffff;
  }

  .custom-tr {
    border: none;
  }

  .custom-th,
  .custom-td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd; /* 添加单元格边框 */
  }

  .custom-th {
    font-weight: bold;
  }

  .custom-th {
    font-weight: bold;
  }
}
</style>
